import { render } from "./Current.vue?vue&type=template&id=0e4dff15&scoped=true"
import script from "./Current.vue?vue&type=script&lang=js"
export * from "./Current.vue?vue&type=script&lang=js"

import "./Current.vue?vue&type=style&index=0&id=0e4dff15&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0e4dff15"

export default script